import { useEffect, useState } from 'react';
import { stripField } from './utils/stripField';
import { DividerField } from './fields/DividerField';
import { TitleField } from './fields/TitleField';
import { SignatureField } from './fields/SignatureField';
import { DisclaimerField } from './fields/DisclaimerField';
import { RobeSizesField } from './fields/RobeSizesField';
import { TextField } from './fields/TextField';
import { PickerField } from './fields/PickerField';
import { CheckboxGroupField } from './fields/CheckboxGroupField';
import { ImagePickerField } from './fields/ImagePickerField';
import { InfiniteListField } from './fields/InfiniteListField';
import { MultiLevelComboboxField } from './fields/MultiLevelComboboxField';
import { MapField } from './fields/MapField';
import { ProductsField } from './fields/ProductsField';
import { RadioButtonGroupField } from './fields/RadioButtonGroupField';

export const CreateEditFields = ({
  field,
  onFieldChange,
}: {
  field: any;
  onFieldChange: (field: any) => void;
}) => {
  const [localField, setLocalField] = useState<any>(field);
  const [option, setOption] = useState<string>('');

  useEffect(() => {
    const strippedField: any = stripField(localField);

    onFieldChange(strippedField);
  }, [localField]);

  const getField = () => {
    if (!field) return null;

    switch (field.type) {
      case 'robeSizes':
        return <RobeSizesField field={localField} setField={setLocalField} />;
      case 'divider':
        return <DividerField field={localField} setField={setLocalField} />;
      case 'picker':
        return (
          <PickerField
            field={localField}
            setField={setLocalField}
            option={option}
            setOption={setOption}
          />
        );
      case 'radioButtonGroup':
        return (
          <RadioButtonGroupField
            field={localField}
            setField={setLocalField}
            option={option}
            setOption={setOption}
          />
        );
      case 'checkboxGroup':
        return (
          <CheckboxGroupField
            field={localField}
            setField={setLocalField}
            option={option}
            setOption={setOption}
          />
        );
      case 'imagePicker':
        return <ImagePickerField field={localField} setField={setLocalField} />;
      case 'title':
        return <TitleField field={localField} setField={setLocalField} />;
      case 'signature':
        return <SignatureField field={localField} setField={setLocalField} />;
      case 'disclaimer':
        return <DisclaimerField field={localField} setField={setLocalField} />;
      case 'infinite-list':
        return (
          <InfiniteListField field={localField} setField={setLocalField} />
        );
      case 'multi-level-combobox':
        return (
          <MultiLevelComboboxField
            field={localField}
            setField={setLocalField}
          />
        );
      case 'map':
        return <MapField field={localField} setField={setLocalField} />;
      case 'products':
        return <ProductsField field={localField} setField={setLocalField} />;
      case 'textarea':
      case 'text':
      case 'tel':
      case 'email':
      case 'datepicker':
        return <TextField field={localField} setField={setLocalField} />;
      default:
        return null;
    }
  };

  return getField();
};
